module.exports = __webpack_public_path__ + "static/img/coming-soon-en.47b0d3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blog/coming-soon-en.png
// module id = 78
// module chunks = 0